import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2021重庆两会特别报道';
const baseUrl = 'lianghui2021-report-h5';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
